import * as proformaUploadTypes from './proformaUploadTypes';

const initialState = {
  dateFrom_input: undefined,
  dateTo_input: undefined,
};

const proformaUploadFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case proformaUploadTypes.CLEAR_FILTER:
      return { ...state, ...initialState };

    case proformaUploadTypes.ON_CHANGE:
      return {
        ...state,
        ...action.payload,
      };

    case proformaUploadTypes.ON_CHANGE_DATE:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export { initialState };
export default proformaUploadFilterReducer;
